<template>
  <g>
    <g clip-path="url(#clip0_15_865)">
      <path
        d="M20 12.0002C20 9.46024 18.81 7.19024 16.96 5.73024L16.28 1.67024C16.12 0.710244 15.28 0.000244141 14.31 0.000244141H9.7C8.72 0.000244141 7.88 0.710244 7.72 1.67024L7.05 5.73024C5.19 7.19024 4 9.45024 4 12.0002C4 14.5502 5.19 16.8102 7.05 18.2702L7.72 22.3302C7.88 23.2902 8.72 24.0002 9.7 24.0002H14.31C15.29 24.0002 16.12 23.2902 16.28 22.3302L16.96 18.2702C18.81 16.8102 20 14.5402 20 12.0002ZM6 12.0002C6 8.69024 8.69 6.00024 12 6.00024C15.31 6.00024 18 8.69024 18 12.0002C18 15.3102 15.31 18.0002 12 18.0002C8.69 18.0002 6 15.3102 6 12.0002Z"
      />
    </g>
    <defs>
      <clipPath id="clip0_15_865">
        <rect
          width="24"
          height="24"
          fill="white"
          transform="translate(0 0.000244141)"
        />
      </clipPath>
    </defs>
  </g>
</template>
